export function gridMessages() {
	return {
		commands: {
			cancel: "Zruš změny",
			canceledit: "Storno",
			create: "Přidej záznam",
			destroy: "Smaž záznam",
			edit: "Uprav",
			save: "Ulož změny",
			select: "Vyber",
			update: "Ulož"
		}
	}
}
export function gridFilterableMessages() {
	return {
		and: "a",
		or: "nebo",
		filter: "Použij",
		clear: "Zruš filtr",
		info: "Vyber položky které:",
		title: "Vyber položky které:",
		isFalse: "Ne",
		isTrue: "Ano",
		search: "Hledej",
		selectValue: "Vyber hodnotu",
		selectedItemsFormat: "{0} vybraných položek",
		operator: "Operátor",
		additionalOperator: "Další operátor",
		value: "Hodnota",
		additionalValue: "Další hodnota",
		logic: "Logic",
		checkAll: "Vyber vše"
	}
}



export function gridFilterableOperators() {
	return {
		string: {
			contains: "Obsahuje",
			eq: "=",
			neq: "!=",
			isnull: "prázdné",
			isnotnull: "neprázdné",
			startswith: "začíná na",
			doesnotstartwith: "Nezačíná na",
			contains: "Obsahuje",
			doesnotcontain: "neobsahuje",
			endswith: "končí na",
			doesnotendwith: "nekončí na"
		}
		, number: {
			eq: "=",
			neq: "!=",
			isnull: "prázdné",
			isnotnull: "neprázdné",
			gte: ">=",
			gt: ">",
			lte: "<=",
			lt: "<"
		}
		, date: {
			dt: "Dne",
			eq: "=",
			neq: "!=",
			isnull: "prázdné",
			isnotnull: "neprázdné",
			gte: ">=",
			gt: ">",
			lte: "<=",
			lt: "<"
		}
		, enums: {
			eq: "=",
			neq: "!=",
			isnull: "prázdné",
			isnotnull: "neprázdné"
		}
		, boolean: {
			eq: "=",
			neq: "!=",
			isnull: "prázdné",
			isnotnull: "neprázdné"
		}
	}

}
export function gridColumnMenuMessages() {
	// pouze doplnuje české překlady
	return {
		movePrev: "Posuň doleva",
		moveNext: "Posuň doprava",
		groupColumn: "Seskupit sloupce",
		ungroupColumn: "Rozdělit sloupce"
	}
}